import { useState } from 'react';

const PRESET_COLORS = [
  '#2196F3', '#4CAF50', '#FF9800', '#F44336', '#9C27B0',
  '#00BCD4', '#795548', '#607D8B', '#E91E63', '#3F51B5',
];

function RoleManager({ allRoles, onAdd, onEdit, onRemove, onClose }) {
  const [newName, setNewName] = useState('');
  const [newColor, setNewColor] = useState(PRESET_COLORS[0]);
  const [editingId, setEditingId] = useState(null);
  const [editName, setEditName] = useState('');
  const [editColor, setEditColor] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  async function handleAdd(e) {
    e.preventDefault();
    if (!newName.trim()) return;
    setSaving(true);
    setError(null);
    try {
      await onAdd(newName, newColor);
      setNewName('');
    } catch (err) {
      setError(err.message);
    } finally {
      setSaving(false);
    }
  }

  function startEdit(role) {
    setEditingId(role.id);
    setEditName(role.name);
    setEditColor(role.color);
  }

  async function saveEdit() {
    if (!editName.trim()) return;
    setSaving(true);
    setError(null);
    try {
      await onEdit(editingId, { Title: editName.trim(), Color: editColor });
      setEditingId(null);
    } catch (err) {
      setError(err.message);
    } finally {
      setSaving(false);
    }
  }

  async function handleToggleActive(role) {
    setSaving(true);
    try {
      await onEdit(role.id, { IsActive: !role.isActive });
    } catch (err) {
      setError(err.message);
    } finally {
      setSaving(false);
    }
  }

  async function handleDelete(role) {
    if (!window.confirm(`Delete role "${role.name}"? This cannot be undone.`)) return;
    try {
      await onRemove(role.id);
    } catch (err) {
      setError(err.message);
    }
  }

  return (
    <div className="RoleManager-overlay" onClick={onClose}>
      <div className="RoleManager" onClick={e => e.stopPropagation()}>
        <div className="RoleManager-header">
          <h3>Manage Roles</h3>
          <button className="RoleManager-close" onClick={onClose}>&times;</button>
        </div>

        {error && <p className="Fitness-error">{error}</p>}

        <div className="RoleManager-list">
          {allRoles.map(role => (
            <div key={role.id} className={`RoleManager-item${role.isActive ? '' : ' RoleManager-item--inactive'}`}>
              {editingId === role.id ? (
                <div className="RoleManager-edit-row">
                  <input
                    className="RoleManager-input"
                    type="text"
                    value={editName}
                    onChange={e => setEditName(e.target.value)}
                  />
                  <div className="RoleManager-colors">
                    {PRESET_COLORS.map(c => (
                      <button
                        key={c}
                        className={`RoleManager-color-dot${editColor === c ? ' RoleManager-color-dot--selected' : ''}`}
                        style={{ background: c }}
                        onClick={() => setEditColor(c)}
                      />
                    ))}
                  </div>
                  <div className="RoleManager-edit-actions">
                    <button className="Fitness-btn Fitness-btn--small" onClick={saveEdit} disabled={saving}>Save</button>
                    <button className="Fitness-btn Fitness-btn--small Fitness-btn--secondary" onClick={() => setEditingId(null)}>Cancel</button>
                  </div>
                </div>
              ) : (
                <div className="RoleManager-display-row">
                  <span className="RoleManager-dot" style={{ background: role.color }} />
                  <span className="RoleManager-name">{role.name}</span>
                  <div className="RoleManager-actions">
                    <button className="Fitness-btn-icon" onClick={() => startEdit(role)} title="Edit">&#9998;</button>
                    <button className="Fitness-btn-icon" onClick={() => handleToggleActive(role)} title={role.isActive ? 'Deactivate' : 'Activate'}>
                      {role.isActive ? '\u25CF' : '\u25CB'}
                    </button>
                    <button className="Fitness-btn-icon Fitness-btn-icon--delete" onClick={() => handleDelete(role)} title="Delete">&times;</button>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>

        <form className="RoleManager-add" onSubmit={handleAdd}>
          <input
            className="RoleManager-input"
            type="text"
            placeholder="New role name"
            value={newName}
            onChange={e => setNewName(e.target.value)}
            required
          />
          <div className="RoleManager-colors">
            {PRESET_COLORS.map(c => (
              <button
                key={c}
                type="button"
                className={`RoleManager-color-dot${newColor === c ? ' RoleManager-color-dot--selected' : ''}`}
                style={{ background: c }}
                onClick={() => setNewColor(c)}
              />
            ))}
          </div>
          <button className="Fitness-btn Fitness-btn--small" type="submit" disabled={saving}>
            {saving ? 'Adding...' : '+ Add Role'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default RoleManager;
